
<template>
    <div id="divMap" style="height: 100%; width: 100%">
        <!-- 添加定位地图弹出框    -->
        <div id="checkPop">
            <comCheckPop
                :checkPopInfo="checkPopInfo"
                @cancleCheck="cancleCheck"
                @checkFinsh="checkFinsh"
            ></comCheckPop>
        </div>
    </div>
</template>
<script>
import {
    fullScreenStartLoading,
    fullScreenEndLoading,
} from '@/V3/js/loading.js'
import { initMap, changeBaseLayer, addWfsLayer } from '@/V3/js/map.js'
import { line_style, plane_style, point_style } from '@/V3/js/mapStyle.js'
import comCheckPop from '@/V3/Main/Check/comCheckPop'

import 'ol/ol.css'
import { Map, View, Overlay } from 'ol'

import VectorSource from 'ol/source/Vector'
import GeoJSONFormat from 'ol/format/GeoJSON'

import VectorLayer from 'ol/layer/Vector'
import { transform, transformExtent, fromLonLat } from 'ol/proj'
import { OSM, TileWMS, Vector } from 'ol/source'

import Draw from 'ol/interaction/Draw'
import { unByKey } from 'ol/Observable.js'
import { WFS, GeoJSON } from 'ol/format'
import { MultiLineString, Point } from 'ol/geom'
import { Circle, Stroke, Style, Fill, Icon, Text } from 'ol/style'

import Feature from 'ol/Feature'
import {
    and as andFilter,
    equalTo as equalToFilter,
    like as likeFilter,
} from 'ol/format/filter'
import axios from 'axios'
import { Modify, Snap, Select } from 'ol/interaction'

import { toLonLat } from 'ol/proj'
import { toStringHDMS } from 'ol/coordinate'

import eventBus from '@/V3/js/eventBus'

export default {
    data() {
        return {
            tName: '',
            // OpenLayers Map对象
            map: {},
            centerLonLat: [101, 37.8],
            zoomLevel: 7,
            // 当前页待审核图层
            currentPageCheckLayer: {},
            //checkPop 审核弹出框
            checkPop: {},
            checkPopInfo: {
                censusenum: null,
                check_reas: null,
                check_stat: null,
                coor_x: null,
                coor_y: null,
                distance: null,
                excursus: null,
                fid_: null,
                household: null,
                id: null,
                input_reas: null,
                input_time: null,
                input_work: null,
                lev2: null,
                lev2_name: null,
                lev3: null,
                location: null,
                location_1: null,
                location_s: null,
                n_position: null,
                name: null,
                other: null,
                population: null,
                remark: null,
                tlocation: null,
                user: null,
            },
            // 当前矢量点
            highLightFeature: {},
        }
    },
    components: {
        comCheckPop,
    },
    mounted() {
        this.gettName()
        this.map = initMap('divMap', this.centerLonLat, this.zoomLevel)
        changeBaseLayer(this.map, 'image')
        this.addStaticLayer1()
        //
        this.refresh(
            0,
            10,
            'coor_x>0 and coor_y >0 and location_1=0 and check_stat=0'
        )
        eventBus.on('pageTurn', (value) => {
            this.refresh(value.startIndex, value.size, value.CQL_FILTER)
        })
        eventBus.on('beginCheck', (value) => {
            // 待审核 开始审核
            this.beginCheck(value)
        })
        this.initCheckPop()
    },
    created() {},
    methods: {
        // dateFormat
        dateFormat(format) {
            var date = new Date()
            var format_arr = {
                Y: date.getFullYear(),
                m:
                    date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : '0' + (date.getMonth() + 1),
                d: date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(),
                H:
                    date.getHours() >= 10
                        ? date.getHours()
                        : '0' + date.getHours(),
                i:
                    date.getMinutes() >= 10
                        ? date.getMinutes()
                        : '0' + date.getMinutes(),
                s:
                    date.getSeconds() >= 10
                        ? date.getSeconds()
                        : '0' + getSeconds(),
            }
            for (var key in format_arr) {
                format = format.replace(key, format_arr[key])
            }
            return format
        },
        //gettName() // 当前系统用户名真实姓名
        gettName() {
            axios({
                url: $webConfig.V3.backendAPI + 'getUsertName',
                method: 'post',
                data: JSON.stringify({
                    mail: this.getUser(),
                }),
            }).then((res) => {
                if (res.data.tName) {
                    this.tName = res.data.tName
                } else {
                    this.tName = ''
                }
            })
        },
        // getUser() // 当前系统用户名
        getUser() {
            if (this.$cookie.get('mail') == null) {
                return this.$store.state.V3mail
            } else {
                return this.$cookie.get('mail')
            }
        },
        // 初始化审核弹出框
        initCheckPop() {
            var container = document.getElementById('checkPop')
            this.checkPop = new Overlay({
                element: container,
                autoPan: true,
                offset: [0, -10],
                positioning: 'bottom-center',
                stopEvent: true,
                autoPanAnimation: { duration: 250 },
            })
            this.map.addOverlay(this.checkPop)
            this.checkPop.setPosition(undefined)
        },
        // 加载静态图层
        addStaticLayer1(){
            let my_line_style = new line_style('')
            let my_plane_style = new plane_style()
            let my_point_style = new point_style('')

            // 缩放到县图层
            let zoomToCountyLayerUrl =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gcounty&outputFormat=application/json'

            let zoomToCountyStyle = my_plane_style.prefecture_seat_tranparent
            this.zoomToCountyLayer = addWfsLayer(
                zoomToCountyLayerUrl,
                zoomToCountyStyle,
                '缩放到县图层',
                8
            )
            this.map.addLayer(this.zoomToCountyLayer)
                   // //加载现代甘肃省市级政区边界
            let county_now_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gmodernline&outputFormat=application/json'

            let county_now_wfs_style = my_line_style.gmodern
            let county_now_layer = addWfsLayer(
                county_now_wfs_url,
                county_now_wfs_style,
                '现代甘肃省级边界',
                5
            )
            this.map.addLayer(county_now_layer)
            // 加载1911年甘肃县政区边界
            let county_old_wfs_url2 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline3&outputFormat=application/json'

            let county_old_wfs_style2 = my_line_style.county_old2
            let county_old_layer2 = addWfsLayer(
                county_old_wfs_url2,
                county_old_wfs_style2,
                '1911年甘肃县级边界',
                5
            )
            this.map.addLayer(county_old_layer2)
                    //加载1911年甘肃市政区边界
            let county_old_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline2&outputFormat=application/json'

            let county_old_wfs_style1 = my_line_style.county_old1
            let county_old_layer1 = addWfsLayer(
                county_old_wfs_url1,
                county_old_wfs_style1,
                '1911年甘肃府级边界',
                5
            )
           this.map.addLayer(county_old_layer1)
          //加载1911年甘肃省政区边界
            let county_old_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gline1&outputFormat=application/json'

            let county_old_wfs_style = my_line_style.county_old
            let county_old_layer = addWfsLayer(
                county_old_wfs_url,
                county_old_wfs_style,
                '1911年甘肃省级边界',
                5
            )
            this.map.addLayer(county_old_layer)
    
     
            // 加载1911年县级政区治所
            let county_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint3&outputFormat=application/json'

            // let county_seat_wfs_style = function (feature, resolution) {
            //     let text = ''
            //     if (resolution > 2319) {
            //         text = ''
            //     } else {
            //         text = feature.getProperties().NAME_CH
            //     }

            //     let style = new point_style(text)

            //     return style.county_seat_label
            // }
            let county_seat_wfs_style = my_point_style.county_seat_label
            this.county_seat_layer = addWfsLayer(
                county_seat_wfs_url,
                county_seat_wfs_style,
                '1911年甘肃县级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer)
            // 加载1911年府级政区治所
            let county_seat_wfs_url1 =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint2&outputFormat=application/json'

            
            let county_seat_wfs_style1 = my_point_style.county_seat_label1
            this.county_seat_layer1 = addWfsLayer(
                county_seat_wfs_url1,
                county_seat_wfs_style1,
                '1911年甘肃府级治所',
                5
            )
            this.map.addLayer(this.county_seat_layer1)
            //加载1911年省级政区治所
            let province_seat_wfs_url =
                $webConfig.V3.owsBaseURL +
                '?service=WFS&version=1.0.0&request=GetFeature&typeName=lwdgis:gpoint1&outputFormat=application/json'
            let province_seat_wfs_style = my_point_style.province_seat
            this.prefecture_seat_layer = addWfsLayer(
                province_seat_wfs_url,
                province_seat_wfs_style,
                '1911年甘肃省级治所',
                5
            )
            this.map.addLayer(this.prefecture_seat_layer)

         
        },
      
        // 刷新图层 和左侧表格当前页数据做联动
        refresh(startIndex, size, CQL_FILTER) {
            this.map.removeLayer(this.currentPageCheckLayer)
            let url_params = {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'lwdgis:v3data',
                outputFormat: 'application/json',
                sortBy: 'id',
                startIndex: startIndex,
                maxFeatures: size,
                CQL_FILTER: CQL_FILTER,
            }
            let self = this
            let vtSource = new VectorSource({
                format: new GeoJSONFormat({
                    // geometryName: 'geom' // 因为数据源里面字段the_geom存储的是geometry，所以需要指定
                }),
                loader: function (extent, resolution, projection) {
                    axios({
                        url: $webConfig.V3.owsBaseURL,
                        method: 'get',
                        params: url_params,
                    }).then((res) => {
                        var featureList = vtSource
                            .getFormat()
                            .readFeatures(res.data)
                        featureList.forEach((item, index) => {
                            item.setGeometry(
                                item
                                    .getGeometry()
                                    .transform('EPSG:4326', 'EPSG:3857')
                            )
                            vtSource.addFeature(item)
                        })
                    })
                },
            })

            let wfsVectorSource = vtSource
            let my_point_style = new point_style('')

            let pointStyle = function (feature, resolution) {
                let text = ''
                if (resolution > 2319) {
                    text = ''
                } else {
                    text = feature.getProperties().name
                }

                my_point_style.default.getText().setText(text)
                return my_point_style.default
            }

            this.currentPageCheckLayer = new VectorLayer({
                source: wfsVectorSource,
                style: pointStyle,
                title: '当前页待审核图层',
                zIndex: 999,
            })

            this.map.addLayer(this.currentPageCheckLayer)
        },
        // 待审核开始审核
        beginCheck(value) {
            // 恢复上次点击要素的符号
            let self = this
            if (self.highLightFeature != undefined) {
                if (self.highLightFeature.setStyle != undefined) {
                    self.highLightFeature.setStyle('')
                }
            }
            this.currentPageCheckLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    let property = feature.getProperties()
                    if (property.id == value.id) {
                        //为选中的Point 添加样式
                        this.highLightFeature = feature
                        let my_point_style = new point_style(
                            feature.getProperties().name
                        )
                        this.highLightFeature.setStyle(my_point_style.highlight)

                        this.checkPopInfo = property
                        let centerLontat = [
                            feature.getGeometry().getExtent()[0],
                            feature.getGeometry().getExtent()[1],
                        ]
                        this.checkPop.setPosition(centerLontat)
                        this.map
                            .getView()
                            .setCenter([
                                centerLontat[0],
                                centerLontat[1] + 20000,
                            ])
                        this.map.getView().setZoom(7.5)
                    }
                })
        },
        // 审核pop 关闭 待审核取消
        cancleCheck() {
            // 恢复上次点击要素的符号
            let self = this
            if (self.highLightFeature != undefined) {
                if (self.highLightFeature.setStyle != undefined) {
                    self.highLightFeature.setStyle('')
                }
            }
            this.checkPop.setPosition(undefined)
        },
        // 待审核审核完毕
        checkFinsh(value) {
            // 审核通过
            if (value.check_stat == 1) {
                this.passSuccess(value)
            }
            // 审核不通过
            if (value.check_stat == 2) {
                this.passFailed(value)
            }
        },
        // 审核通过 改变数据
        // 数据点改变 积分改变 审核通过表记录下来
        passSuccess(value) {
            this.cancleCheck()
            let self = this
            let features = []
            this.currentPageCheckLayer
                .getSource()
                .getFeatures()
                .forEach((feature) => {
                    if (feature.getProperties().id == value.data.id) {
                        // 注意 要改变 数据点原始属性值 由于投影的原有 经纬度也要跟着改变
                        let centerLonLat = [
                            feature.getGeometry().getExtent()[0],
                            feature.getGeometry().getExtent()[1],
                        ]
                        let transformLonLat = transform(
                            centerLonLat,
                            'EPSG:3857',
                            'EPSG:4326'
                        )
                        let newLonlat = [transformLonLat[1], transformLonLat[0]]
                        feature.getGeometry().setCoordinates(newLonlat)

                        feature.set('check_stat', value.check_stat)
                        feature.set('check_reas', value.check_reas)
                        // 审核日期
                        feature.set('remark', this.dateFormat('Y-m-d H:i:s'))

                        feature.set('location_1', 1)
                        features.push(feature)
                    }
                })
            self.passSuccessXML(features)
        },
        // 审核通过 改变数据发送请求体
        passSuccessXML(features) {
            let self = this
            let WFSTSerializer = new WFS()
            let featObject = WFSTSerializer.writeTransaction(
                null,
                features,
                null,
                {
                    featureType: 'v3data', //feature对应图层
                    featureNS: $webConfig.V3.GeoseverIP + '/lwdgis', //为创建工作区时的命名空间URI
                    geometryName: 'geom',
                }
            )
            // 转换为xml内容发送到服务器端
            let serializer = new XMLSerializer()
            let featString = serializer.serializeToString(featObject)

            const axioInstance = axios.create()
            // 请求拦截器
            axioInstance.interceptors.request.use(
                (config) => {
                    fullScreenStartLoading()
                    return config
                },
                (error) => {
                    Promise.reject(error)
                }
            )
            // 响应拦截器
            axioInstance.interceptors.response.use(
                (response) => {
                    fullScreenEndLoading()
                    return response
                },
                (error) => {
                    fullScreenEndLoading()
                    return Promise.reject(error)
                }
            )
            // 发送请求
            axioInstance
                .post(
                    $webConfig.V3.GeoseverIP + '/wfs?service=wfs',
                    this.replaceText(featString, 'geom', 'v3data'),
                    {
                        headers: {
                            'Content-Type': 'text/xml',
                        },
                    }
                )
                .then((e) => {
                    self.successRecordOperation(
                        '数据点定位审核',
                        '审核完成，审核通过',
                        features[0].getProperties()
                    )
                    if (e.status == 200) {
                        // console.log(e)
                        self.$message({
                            message: '审核完成',
                            type: 'success',
                        })
                        // 重新加载左侧表格组件 右侧地图组件
                        // self.reloadTimer = new Date().getTime()
                        self.$emit('reloadComponents')
                    }
                })
        },
        // 不知道为什么 更改点位置 的xml 请求体有问题 替换其中的关键字即可
        // 找了好久
        replaceText(text, key1, key2) {
            let temp1 = 'feature:' + key2
            let temp2 = 'lwdgis:' + key2
            return text.replace('geometry', key1).replace(temp1, temp2)
        },
        // 记录操作记录
        successRecordOperation(content, result, property) {
            // // 记录用户行为 修改数据
            // 注意日期
            let operationJSON = {
                mail: this.getUser(),
                tName: this.tName,
                dataID: property.id,
                juluo: property.name,
                country: property.lev2_name,
                date: this.dateFormat('Y-m-d H:i:s'),
                content: content,
                result: result,
                other: '',
            }
            let pointsAdd = {
                // 注意用户名别搞错了
                mail: property.user,
                points: '10',
            }
            let passDataAdd = {
                // 注意用户名别搞错了
                // 注意日期
                mail: property.user,
                tName: property.other,
                work: property.input_work,
                dataID: property.id,
                juluo: property.name,
                country: property.lev2_name,
                location: property.coor_x + ',' + property.coor_y,
                nPosition: property.n_position,
                date: property.input_time,
                other: property.input_reas,
                checkDate: this.dateFormat('Y-m-d H:i:s'),
            }
            axios.post($webConfig.V3.backendAPI + 'addOperation', operationJSON)
            axios.post(
                $webConfig.V3.backendAPI + 'addCheckOperation',
                passDataAdd
            )
            // 审核通过改变积分
            axios.post($webConfig.V3.backendAPI + 'changePoints', pointsAdd)
        },

        // 审核不通过 改变数据
        // 数据点改变 如果是从来没有定位的点回到未通过 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态
        // 历史记录记录
        passFailed(value) {
            let self = this
            this.cancleCheck()
            // 判断是哪一种
            // 如果是从来没有定位的点回到未通过 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态
            let dataID = value.data.id + ''
            axios({
                url: $webConfig.V3.backendAPI + 'getPassDatas',
                method: 'post',
                data: JSON.stringify({
                    dataID: dataID,
                }),
            }).then((res) => {
                if (res.data.data.count == 0) {
                    // 如果是从来没有定位的点回到未通过

                    let features = []
                    this.currentPageCheckLayer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.data.id) {
                                // 注意 要改变 数据点原始属性值 由于投影的原有 经纬度也要跟着改变
                                let centerLonLat = [
                                    feature.getGeometry().getExtent()[0],
                                    feature.getGeometry().getExtent()[1],
                                ]
                                let transformLonLat = transform(
                                    centerLonLat,
                                    'EPSG:3857',
                                    'EPSG:4326'
                                )
                                let newLonlat = [
                                    transformLonLat[1],
                                    transformLonLat[0],
                                ]
                                feature.getGeometry().setCoordinates(newLonlat)

                                feature.set('check_stat', value.check_stat)
                                feature.set('check_reas', value.check_reas)
                                // 审核日期
                                feature.set(
                                    'remark',
                                    this.dateFormat('Y-m-d H:i:s')
                                )
                                feature.set('location_1', 0)
                                features.push(feature)
                            }
                        })
                    // self.passSuccessXML(features)
                    self.passFailedXML(features, value)
                } else {
                    // 如果是是之前通过的点用户更改坐标审核的回到更改之前的状态

                    let originData =
                        res.data.data.resList[res.data.data.count - 1]
                    let features = []
                    this.currentPageCheckLayer
                        .getSource()
                        .getFeatures()
                        .forEach((feature) => {
                            if (feature.getProperties().id == value.data.id) {
                                // 注意 要改变 数据点原始属性值 由于投影的原有 经纬度也要跟着改变

                                let lonlat = originData.location.split(',')

                                feature
                                    .getGeometry()
                                    .setCoordinates([
                                        parseFloat(lonlat[0]),
                                        parseFloat(lonlat[1]),
                                    ])
                                feature.set('coor_x', parseFloat(lonlat[0]))
                                feature.set('coor_y', parseFloat(lonlat[1]))
                                feature.set('n_position', originData.n_position)
                                feature.set('user', originData.mail)
                                feature.set('input_time', originData.date)
                                feature.set('other', originData.tName)

                                feature.set('input_work', originData.work)
                                feature.set('input_reas', originData.other)
                                // 审核日期
                                feature.set('remark', originData.checkDate)

                                feature.set('check_stat', 1)
                                feature.set('location_1', 1)
                                features.push(feature)
                            }
                        })
                    self.passFailedXML(features, value)
                }
            })
        },
        // 审核不通过 改变数据发送请求体
        passFailedXML(features, value) {
            let self = this
            let WFSTSerializer = new WFS()
            let featObject = WFSTSerializer.writeTransaction(
                null,
                features,
                null,
                {
                    featureType: 'v3data', //feature对应图层
                    featureNS: $webConfig.V3.GeoseverIP + '/lwdgis', //为创建工作区时的命名空间URI
                    geometryName: 'geom',
                }
            )
            // 转换为xml内容发送到服务器端
            let serializer = new XMLSerializer()
            let featString = serializer.serializeToString(featObject)

            const axioInstance = axios.create()
            // 请求拦截器
            axioInstance.interceptors.request.use(
                (config) => {
                    fullScreenStartLoading()
                    return config
                },
                (error) => {
                    Promise.reject(error)
                }
            )
            // 响应拦截器
            axioInstance.interceptors.response.use(
                (response) => {
                    fullScreenEndLoading()
                    return response
                },
                (error) => {
                    fullScreenEndLoading()
                    return Promise.reject(error)
                }
            )
            // 发送请求
            axioInstance
                .post(
                    $webConfig.V3.GeoseverIP + '/wfs?service=wfs',
                    this.replaceText(featString, 'geom', 'v3data'),
                    {
                        headers: {
                            'Content-Type': 'text/xml',
                        },
                    }
                )
                .then((e) => {
                    self.failedRecordOperation(
                        '数据点定位审核',
                        '审核完成，审核不通过',
                        features[0].getProperties()
                    )
                    if (e.status == 200) {
                        // console.log(e)
                        self.$message({
                            message:
                                '审核完成，该聚落审核不通过，已通知该定位用户。',
                            type: 'success',
                        })
                        // 发送审核不成功邮件
                        axios({
                            url: $webConfig.V3.backendAPI + 'sendMail',
                            method: 'post',
                            data: JSON.stringify({
                                name: value.data.name,
                                lev2_name: value.data.lev2_name,
                                input_reas: value.data.input_reas,
                                input_time: value.data.input_time,
                                check_reas: value.check_reas,
                                user: value.data.user,
                            }),
                        })
                        // 重新加载左侧表格组件 右侧地图组件
                        // self.reloadTimer = new Date().getTime()
                        self.$emit('reloadComponents')
                    }
                })
        },
        failedRecordOperation(content, result, property) {
            // // 记录用户行为 修改数据
            // 注意日期
            let operationJSON = {
                mail: this.getUser(),
                tName: this.tName,
                dataID: property.id,
                juluo: property.name,
                country: property.lev2_name,
                date: this.dateFormat('Y-m-d H:i:s'),
                content: content,
                result: result,
                other: '',
            }
            axios.post($webConfig.V3.backendAPI + 'addOperation', operationJSON)
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/V3/Main/Check/comRightMap.vue